const addCampaigns = {
  products: 'Товары',
  services: 'Услуги',
  pickAvaialbleCampaignTypes: 'Выберите один из доступных типов кампаний',
  notes: 'Заметки',
  pleaseDontChangeYourAppsIcon: 'Пожалуйста, не меняйте значок, имя или имя издателя вашего приложения во время проведения кампании. Наши пользователи будут искать ваше приложение по ключевым словам, и единственный способ найти его — посмотреть на значок и сравнить название приложения.',
  whatIsAdvertisingCpiCampign: 'Что такое рекламная компания CPI?',
  cpi: 'CPI (cost-per-install) компания - это инструмент, используемый для привлечения пользователей в ваше приложение. Эти пользователи не мотивированы драгоценными камнями или монетами, как те, кто устанавливает ваше приложение, когда вы заказываете установку по ключевому слову. Эти пользователи установят ваше приложение, только если оно им понравится. Это означает, что вы будете привлекать людей, которые приносят вам доход и активность в приложении.',
  keyword: 'Ключевое слово',
  install: 'установить',
  direct: 'Прямой',
  installs: 'Установок',
  guaranteed: 'Гарантировано',
  reviews: 'Отзывы',
  impressions: 'Покази',
  smart: 'Умная',
  campaign: 'Кампания',
  addCampaigns: 'Добавить кампании',
  addCampaign: 'Добавить кампанию',
  advertising: 'Реклама',
  summary: 'Резюме',
  product: 'Товар',
  keywordInstalls: 'Установки по ключевому слову',
  installsByKeywordsForYourApplication: 'Количество установок по ключевым словам для вашего приложения в целевом регионе',
  installsByDirectLink: 'Установка по прямой ссылке приложения в выбранном регионе',
  reviewsForYourApplication: 'Отзывы о вашей заявке в выбранном регионе с 3-недельней гарантией на пополнение счета и возврат средств',
  installsGeneratedByAppsYourApplication: 'Установки, сгенерированные рекламой для вашей программы в выбранных регионах',
  cpiShort: 'Компания CPI (цена установки) – это инструмент, используемый для привлечения пользователей к вашему приложению.',
  advertisingCpiCampaign: 'Рекламная кампания CPI',
  application: 'Приложение',
  targetCountry: 'Целевая страна',
  daysInCampaign: 'Дней в кампании',
  finishAt: 'Закончить в',
  campaignOrders: 'Campaign orders',
  days: 'дни',
  directInstalls: 'Прямые установки',
  rates: 'Ставки',
  total: 'Итого',
  day: 'День',
  fixedPartner: 'Фиксированный партнер',
  description: 'Описание',
  saveDraft: 'Сохранить черновик',
  draft: 'Черновик',
  delay: 'Отложить',
  startCampaign: 'Начать кампанию.',
  startNow: 'Создать',
  iAgreeTo: 'я согласен с',
  terms: 'условия',
  ofUse: 'использования',
  textSuccessfully: 'Кампания успешно создана',
  textSuccessfullyDraft: 'Создан новый проект кампании № {id}.',
  textErrorCountReviews: 'Минимальное количество установок должно быть {minInstalls} * {days}. Добавьте больше отзывов.',
  refundPolicyForRatesAndReviews: 'Политика возврата средств за тарифы и обзоры',
  almostAllRatesAndReviewsAreGettingDeleted: 'Предупреждение! Почти все оценки и отзывы удаляются любым магазином приложений, мы НЕ вернем деньги за оценки и отзывы. Используйте их на свой страх и риск',
  allRatesAndReviewsWillAppearOnMarket: 'Все оценки и отзывы появятся на странице вашего приложения в маркете через 2-3 часа после завершения кампании. Через 1-2 дня большинство ставок и обзоров, заказанных в этом разделе, будут удалены, и это сильно зависит от типа вашего приложения, его органического трафика и увеличения обычных ежедневных ставок, поэтому, продолжая, вы соглашаетесь на этот риск.',
  ifYouNeedReviewsAndRates: 'Если вам нужны отзывы и оценки, чтобы оставаться на странице приложения, а также получить их с гарантией возврата денег или репостом в течение 3 недель после выполнения заказа, перейдите в акцию «Добавить гарантированные отзывы».',
  evenIfItIsOkay: 'Даже если вас устраивает, что заказанные в этом разделе рейтинги и отзывы удаляются, не заказывайте их тоннами. Поведение ставок должно быть похоже на реальный поток пользователей, пропорционально органическому трафику вашего приложения в выбранной стране и аналогично вашему текущему количеству ставок.',
  iveReadAndAreeToThe: 'Я прочитал и согласен с',
  chargebackAndRefundPolicy: 'Политика возврата и возврата средств',
  deleteAllKeywords: 'Удалить все ключевые слова',
  minimumOrderInstallsIs: 'Минимальное количество установок для заказа',
  keywordInstall: {
    keywordInstallAddKeywordsBody: {
      keywords: 'Ключевые слова',
      advancedMode: 'Расширенный режим',
      dayOne: 'день 1',
      addKeyword: 'Добавить ключевое слово'
    },
    keywordInstallKeywordsTable: {
      noKeywordsFound: 'Ключевые слова не найдены',
      selectKeyword: 'Выберите ключевое слово',
      addKeywordInstalls: 'Добавить установки по ключевому слову',
      installsDistribution: 'Распределение установок',
      increase: 'Увеличивать',
      parabolic: 'Параболический',
      equal: 'Равный',
      days: 'Дни'
    },
    directInstallTable: {
      addDirectInstalls: 'Перевод',
      days: 'Дни',
      packageOrDirectInstalls: 'Пакетная или прямая установка',
      delete: 'Удалить'
    },
    ratesAndReviewsKeywordInstallBody: {
      ratesAndReviews: 'Цены и отзывы',
      addRatesAndReviewsToCampaign: 'Добавьте оценки и отзывы в кампанию',
      days: 'Дни',
      rates: 'Ставки',
      delete: 'Удалить',
      reviews: 'Отзывы',
      importReviews: 'Импорт отзывов',
      errorCheckedTerms: 'Вы должны согласиться с условиями использования, прежде чем заказывать оценки или обзоры.'
    },
    promotionRuleKeywordInstallBody: {
      promotionRule: 'Правило продвижения',
      dontPromoteKeywordsWhenTheyReachRank: 'Не продвигайте ключевые слова, когда они достигают рейтинга',
      installsDeliveryType: 'Устанавливает тип доставки',
      spreadInstallsForTwentyFourHours: 'Распространение установок за 24 часа',
      allInstallsAtOnce: 'Все установки сразу',
      deeplinkTitle: 'Глубокая ссылка',
      deeplink: 'Глубокая ссылка выполняется после установки приложения, например run?source=keyapp, ',
      deeplinkIos: 'читайте больше в нашем блоге'
    },
    addMyReviewsModal: {
      pleaseWait: 'Обработка, пожалуйста, подождите...',
      addMyReviews: 'Добавить мои отзывы',
      added: 'Добавлен',
      reviews: 'обзоры',
      newReview: 'Добавить новый отзыв',
      addManyRandomReview: 'Добавить 5 случайных отзывов',
      deleteAll: 'Удалить все',
      saveReview: 'Сохранить отзыв',
      deleteReview: 'Удалить отзыв',
      editReview: 'Изменить отзыв',
      youHaveNoAddedReviewsYet: 'У вас еще нет добавленных отзывов',
      add: 'Добавлять',
      errorLength: 'Необходимо минимальное количество отзывов: {min}.',
      titleText: 'Добавьте новое название отзыва',
      bodyText: 'Добавьте новый текст отзыва'
    },
    descriptionKeywordInstallBody: {
      description: 'Описание',
      leaveAnyNotesForYourcampaign: 'Оставляйте любые заметки для вашей кампании (только на английском языке, не более 1000 символов)'
    }
  },
  impressionsSection: {
    title: 'Показы',
    conversionRate: 'Коэффициент конверсии (CVR)',
    impressionsNumberTooltip: 'CVR — чем ниже процент, тем больше показов будет добавлено',
    helpText1: 'Показы помогают поддерживать естественный коэффициент конверсии (CVR), добавляя дополнительные просмотры вашего приложения в результаты поиска',
    helpText2: 'Используйте ползунок, чтобы выбрать целевой CVR — чем ниже процент, тем больше показов будет добавлено',
    helpText3: 'Показы будут равномерно распределены между всеми ключевыми словами и днями кампании'
  },
  guaranteedReviews: {
    reviewGuaranteedReviewsBody: {
      mustBeAtLeast: 'Должно быть по меньшей мере',
      guaranteedReviews: 'Гарантированные отзывы',
      addGuaranreedReviewsToYourApplication: 'Добавьте гарантированные отзывы к вашему приложению',
      myCustom: 'Мой обычай',
      reviews: 'обзоры',
      writeReviews: 'Пишите отзывы',
      forMe: 'для меня',
      improveYourRatesAndAppsReputation: 'Улучшайте свои рейтинги и репутацию приложений с помощью наших обзоров. Получите 3-недельную гарантию на любой заказ.',
      campaignDetails: 'Детали кампании',
      days: 'Дни',
      _reviews: 'Отзывы',
      importReviews: 'Импорт отзывов',
      delete: 'Удалить',
      authorGender: 'Пол автора',
      male: 'Мужской',
      female: 'женский',
      both: 'Оба',
      pickPreferredGenderOfAccount: 'Выберите предпочитаемый пол аккаунта, который напишет отзыв',
      reviewLanguage: 'Язык обзора',
      pickPreferredLanguageForReviews: 'Выберите предпочитаемый язык для отзывов, или будет использоваться язык выбранной страны по умолчанию.',
      description: 'Описание',
      leaveAnyNotesForYourOrder: 'Оставьте любые примечания к вашему заказу (только на английском языке, 1000 символов), например. предпочтительные ключевые слова, фразы и т. д.',
      notes: 'Заметки',
      thisIsGuaranteedReviewsOrder: 'Это гарантированный порядок отзывов, это означает, что при заказе 100 отзывов мы гарантируем, что не менее 90 из них будут оставаться на странице вашего приложения не менее 3 недель, в противном случае мы переопубликуем недостающие отзывы. Также ваш заказ может находиться в статусе МОДЕРАЦИЯ в течение 12-48 часов, пока мы не проверим все отзывы.'
    }
  },
  startModalCpi: {
    customer: 'Клиент'
  },
  advertisingCampaign: {
    advertisingCampaignTab: {
      back: 'Назад',
      startCampaign: 'Начать кампанию',
      pleaseWait: 'Пожалуйста подождите...',
      next: 'Следующий'
    },
    advertisingCampaignStep1: {
      addTargetCountriesForAppPromotion: 'Добавьте целевые страны для продвижения приложения',
      usuallyWeRecommendToStartCpiAampaignsInSuchCases: 'Обычно в таких случаях мы рекомендуем запускать CPI-кампании.',
      youDontHave: 'У вас нет',
      organicTrafficOnYourApp: 'органический трафик в вашем приложении, но вы хотите запустить кампании по продвижению ключевых слов. Когда вы одновременно заказываете установки по ключевым словам и установки CPI, ранжирование ключевых слов вашего приложения повышается намного быстрее.',
      youHave: 'У вас есть',
      newAppAndYouWantToGetKeywordsIndexationFaster: 'новое приложение и вы хотите ускорить индексацию ключевых слов',
      newAppAndYouWantToGetYourMainPageInstallsNumberHigher: 'новое приложение, и вы хотите увеличить количество установок на главной странице',
      toGetBetterCategoryRankings: 'чтобы получить лучший рейтинг в категориях',
      youEarnMore: 'Вы зарабатываете больше',
      fromEachInstallThenYouPayForIt: 'с каждой установки, то вы платите за это',
      toAttractUsersFromSpecifiedRegion: 'для привлечения пользователей из указанного региона',
      cryptocurrenciesBinaryOptionsPersonalLoansAppsAreForbidden: 'Криптовалюты, бинарные опционы, потребительские кредиты и подобные приложения запрещены.',
      youWant: 'Ты хочешь',
      pleaseNote: 'Пожалуйста, обрати внимание'
    },
    advertisingCampaignStep2: {
      selectPromotionCountries: 'Выберите страны акции',
      addTargetCountriesForAppPromotion: 'Добавьте целевые страны для продвижения приложения',
      filterByCpi: 'Сортировать по CPI',
      filterByGeo: 'Сортировать по GEO',
      filterByLanguage: 'Сортировать по language',
      highCpi: 'Высокий CPI',
      mediumCpi: 'Средний CPI',
      lowCpi: 'Низкий CPI',
      europe: 'Европа',
      asia: 'Азия',
      africa: 'Африка',
      latinAmerica: 'Латинская Америка',
      worldwide: 'Мировой',
      english: 'Английский',
      spanish: 'Испанский',
      russian: 'Русский',
      targetedCountries: 'Целевые страны'
    },
    advertisingCampaignStep3: {
      campaignBudget: 'Бюджет кампании',
      defineDailyBudget: 'Определите дневной бюджет, общее количество дней и цель CPI',
      dailyBudget: 'Ежедневный бюджет',
      targetCpi: 'Цель CPI',
      daysInCampaign: 'Дней в кампании',
      unlimited: 'Неограниченный',
      days: 'дни',
      daysInCampaignMustBeAtLeast: 'Количество дней в кампании должно быть не меньше',
    },
    advertisingCampaignStep4: {
      headlines: 'Заголовки',
      addHeadlinesAndDescriptionsForAds: 'Добавьте заголовки и описания для объявлений',
      headlineOne: 'Заголовок #1',
      weUseHeadlinesAndDescriptionsToAdvertiseYourApp: 'Мы используем заголовки и описания для рекламы вашего приложения. Привлекательные заголовки и описания могут помочь вам повысить CTR (больше кликов от просмотров), поэтому ваш средний CPI снизится.',
      generate: 'Создать',
      headlineTwo: 'Заголовок #2',
      misleadingDescriptions: 'Вводящие в заблуждение описания могут повысить CTR, но пользователи не установят ваше приложение, когда зайдут на страницу вашего приложения. Таким образом, вы получите низкий коэффициент конверсии, а ваш CPI увеличится.',
      description: 'Описание',
      checkThatYourTextMakesSenseForUsers: 'Убедитесь, что ваш текст имеет смысл для пользователей. Это важно, потому что наши партнеры из рекламных сетей будут применять процесс утверждения к вашим объявлениям. Если вы нарушите некоторые правила, ваши объявления должны пройти процесс утверждения.',
      headlineOneIsNotSet: 'Заголовок №1 не установлен.',
      headlineOneIsTooShort: 'Заголовок №1 слишком короткий. Минимальная длина:',
      headlineOneIsTooLong: 'Заголовок №1 слишком длинный. Максимальная длина:',
      headlineTwoIsNotSet: 'Заголовок №2 не установлен.',
      headlineTwoIsTooShort: 'Заголовок №2 слишком короткий. Минимальная длина:',
      headlineTwoIsTooLong: 'Заголовок №2 слишком длинный. Максимальная длина:',
      descriptionIsNotSet: 'Описание не установлено.',
      descriptionIsTooShort: 'Описание слишком короткое. Минимальная длина:',
      descriptionIsTooLong: 'Описание слишком длинное. Максимальная длина:',
      headlinesAndDescriptionsShouldBeUnique: 'Заголовки и описания должны быть уникальными.',
    },
    advertisingCampaignStep5: {
      finish: 'Готово!',
      summary: 'Резюме',
      confirmCampaignDetails: 'Подтвердите данные кампании',
      application: 'Приложение',
      nameOfApplication: 'Название приложения...',
      developer: 'Разработчик',
      countries: 'Страны',
      duration: 'Продолжительность',
      targetCpi: 'Цель CPI',
      dailyBudget: 'Ежедневный бюджет',
      startCharge: 'Начать зарядку',
      toStartThisCampaign: 'Чтобы начать эту кампанию, мы спишем с вашего баланса 20 $. Нам нужна эта сумма (на самом деле это удвоенный дневной бюджет) в качестве предоплаты для будущих расходов на кампанию.',
      weWillChargeYourAccount: 'Каждый день мы будем списывать с вашего счета сумму, которую вы потратили на продвижение в течение предыдущего дня. Если на вашем балансе недостаточно средств для покрытия расходов за предыдущий день, мы будем использовать ваш начальный платеж и приостановим кампанию до тех пор, пока вы не пополните свой баланс и не приостановите кампанию вручную.',
      refund: 'Возврат',
      youMayCancelYourCampaign: 'Вы можете отменить свою кампанию в любое время, но мы вернем деньги только через 24 часа после отмены, чтобы остановить кампанию во всех рекламных сетях и получить фактические расходы на кампанию. То же правило относится и к завершению кампаний. Сумма возврата рассчитывается как разница между ценой кампании и затратами на кампанию.',
      dailyCharge: 'Ежедневная зарядка'
    },
    advertisingCampaignAside: {
      letsStart: 'Давайте начнем!',
      createNewCpiCampaign: 'создать новую кампанию CPI',
      budget: 'Бюджет',
      adjustBudget: 'настроить бюджет, CPI и продолжительность',
      regions: 'Регионы',
      selectTargetedCountries: 'выбрать целевые страны',
      headlines: 'Заголовки',
      inputTextForAds: 'ввести текст для объявлений',
      finish: 'Завершить',
      startYourNewCampaign: 'начать новую кампанию',
      selectCountries: 'Выбрать страны',
      detailsOfStepOneHere: 'подробности шага 1 здесь',
      stepTwo: 'Шаг 2',
      detailsOfStepTwoHere: 'подробности шага 2 здесь',
      stepThree: 'Шаг 3',
      detailsOfStepThreeHere: 'подробности шага 3 здесь',
      stepFour: 'Шаг 4',
      detailsOfStepFourHere: 'подробности шага 4 здесь',
      stepFive: 'Шаг 5',
      detailsOfStepFiveHere: 'подробности шага 5 здесь'
    }
  },
  delayedModal: {
    delayedCampaign: 'Задержанная кампания',
    selectTheDate: 'Выберите дату, когда вы хотите начать свою кампанию',
    yourAccountWillBeDebited: 'Средства с вашего счета будут списаны через {date}',
    date: 'Дата',
    time: 'Время',
    dateOrTimeIsEmpty: 'Дата или время пусты',
    pleaseChangeDateOrTime: 'Пожалуйста, введите дату и время, позднее чем на 5 минут',
  },
  addCampaignsHeader: {
    keywordInstalls: 'Установки <br>по ключевым словам',
    directInstalls: 'Прямые <br>установки',
    guaranteedReviews: 'Гарантированные <br>отзывы',
    advertisingCampaign: 'Рекламная <br>кампания'
  },
  addCampaignLoadingModal: {
    title: 'Кампания создается...'
  }
};

export default addCampaigns;
